<template>
  <div v-if="orderId">
    <button type="button" class="btn btn-link btn-sm p-0" @click.stop="show=true">
      {{ orderId }}
    </button>
    <app-modal :modal-in="show" @close="show=false">
      <template #header>Order Details {{ orderId }}</template>
      <div class="container">
        <platform-order :order-id="orderId" />
      </div>
    </app-modal>
  </div>
</template>
<script setup>
import { defineProps, ref } from "vue";
import PlatformOrder from "@/app/components/ebay/PlatformOrder.vue";
import AppModal from "@/app/components/Utils/AppModal.vue";


const show = ref(false)
defineProps(['orderId'])

</script>
